import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import { email, required } from "@vuelidate/validators";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";
  import useVuelidate from "@vuelidate/core";

  interface Props {
    isOpen: boolean;
    message: string;
    isClearForm?: boolean;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPasswordModal',
  props: {
    isOpen: { type: Boolean },
    message: {},
    isClearForm: { type: Boolean }
  },
  emits: ["onSend", "close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;
  const form = ref({
    email: "",
  });
  const rules = {
    email: { required, email, $autoDirty: false },
  };
  const v$ = useVuelidate(rules, form);

  async function onSubmit() {
    v$.value.$touch();
    const isNoErrors = await v$.value.$validate();

    if (!isNoErrors) return;

    emits("onSend", form.value.email);
  }

  function clearForm() {
    resetVuelidateErrors(v$);
    form.value.email = "";
  }

  function onClose() {
    emits("close");
    clearForm();
  }

  watch(
    () => props.isClearForm,
    () => {
      if (props.isClearForm) clearForm();
    },
    { deep: true, immediate: true }
  );

const __returned__ = { emits, props, form, rules, v$, onSubmit, clearForm, onClose, ref, watch, Modal, get email() { return email }, get required() { return required }, get resetVuelidateErrors() { return resetVuelidateErrors }, get useVuelidate() { return useVuelidate } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})